<template>
    <div class="card">
        <div class="row">
            <div class="col-2">
                <div class="card-body text-elev-blue">
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="card-icon">
                        <path stroke-linecap="round" stroke-linejoin="round" d="M2.25 8.25h19.5M2.25 9h19.5m-16.5 5.25h6m-6 2.25h3m-3.75 3h15a2.25 2.25 0 002.25-2.25V6.75A2.25 2.25 0 0019.5 4.5h-15a2.25 2.25 0 00-2.25 2.25v10.5A2.25 2.25 0 004.5 19.5z" />
                    </svg>
                </div>
            </div>
            <div class="col-10">
                <div class="card-body pb-0">
                    <div class="row">
                        <div class="col-12">
                            <h5 class="card-title text-xs">{{ $t('Innskudd') }}</h5>
                            <p class="text-2xl mb-0"><strong>{{ $t('Vil du gjøre et innskudd?') }}</strong></p>
                        </div>
                    </div>
                </div>
                <div>
                    <div class="hr-wrapper mb-4">
                        <hr>
                    </div>
                    <div class="card-body pt-1">
                        <div class="row">
                            <div class="col-12 col-sm-6 pe-sm-1">
                                <a class="btn btn-success btn-block py-2" :href=" '/payment?method=' + paymentMethod + '&deposit=1'"><strong>{{ $t("Innskudd") }}</strong></a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
const props = defineProps(['paymentMethod']);
</script>